import BookingPage from "./BookingPage";
export default function GroundBooking() { return <BookingPage type="ground" />; }
